module.exports = __webpack_public_path__ + "img/helper_phone.a3ec20b0.png";